import { ClinicGroupSelected } from "../../../../api/Clinics/Models/ClinicGroup"

interface IExcludeClinicGroupRowProps {
  group: ClinicGroupSelected
  onClick: (group: ClinicGroupSelected) => void
}

function ExcludeClinicGroupRow(props: IExcludeClinicGroupRowProps) {
  const { group, onClick } = props

  return (
    <tr
      key={group.SearchRestrictId}
      role="button"
      className={`border-top ${group.selected ? "selected" : ""}`}
      onClick={() => onClick(group)}
    >
      <td>{group.Name}</td>
    </tr>
  )
}

export default ExcludeClinicGroupRow
